module.exports = __webpack_public_path__ + "img/login.746f61cc.svg";